import { TBooleanRecord } from "types";

export const checkHasAccess = (
  requiredAccessRights: number[],
  accessRight?: TBooleanRecord
) => {
  let givenAccess = false;

  if (!requiredAccessRights.length) {
    return true;
  }

  for (const access of requiredAccessRights) {
    if (accessRight?.[access]) {
      givenAccess = true;
      break;
    }
  }

  return givenAccess;
};
